import React from "react";

import {BalancesUIProvider} from "../../contexts/BalancesUIContext";
import {BalanceContainer} from '../../components/containers/BalanceContainer';

export function BalancePage() {
  return (
    <BalancesUIProvider>
      <BalanceContainer />
    </BalancesUIProvider>
  );
}
